import { useState } from 'react';

import { Dropdown } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from "styled-components";
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

export default function EditorTranslatable(props) {
  const {
    onChange,
    className = 'mb-3',
    title = '',
    value = {},
    height = 250,
    toolbar = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [
          { list: 'ordered' },
          { list: 'bullet' },
          { indent: '-1' },
          { indent: '+1' },
        ],
        ['link'],
        ['clean'],
        [{ direction: 'rtl' }],
      ],
    },
    onCancel = () => {},
  } = props;
  const { moduleBridgeHex } = useParams();
  const actualLang = useSelector((state) => state.global.urlData.lang);
  const languages = useSelector(
    (state) => state.module?.[moduleBridgeHex].lang
  );
  const [newValues, setNewValues] = useState(value);
  const [selectedLanguage, setSelectedLanguage] = useState(actualLang);

  const handleOnChange = (v, source) => {
    if (source === 'api') return;

    if (
      v === '' ||
      v === '<p><br></p>' ||
      v === undefined ||
      v === null ||
      !v
    ) {
      const {
        [selectedLanguage]: removed,
        ...newValuesWithoutEmptySlug
      } = newValues;
      setNewValues(newValuesWithoutEmptySlug);
      onChange(newValuesWithoutEmptySlug);
    } else if (v) {
      const newLang = { ...newValues };
      newLang[selectedLanguage] = v;
      setNewValues(newLang);
      onChange(newLang);
    } else {
      const {
        [selectedLanguage]: removed,
        ...newValuesWithoutEmptySlug
      } = newValues;
      setNewValues(newValuesWithoutEmptySlug);
      onChange(newValuesWithoutEmptySlug);
    }
  };

  //   useEffect(() => {
  //     setNewValues(values);
  //   }, [values]);

  return (
    <>
      <Title>{title}</Title>
      {selectedLanguage && languages && (
        <div className="d-flex">
          <EditorWrapper height={height}>
            <ReactQuill
              theme="snow"
              className={className}
              modules={toolbar}
              value={newValues[selectedLanguage] || ''}
              onChange={(e, delta, source) => handleOnChange(e, source)}
            />
          </EditorWrapper>
          <Dropdown
            as="div"
            className="dropdown mb-0 mt-0 ml-1 float-right"
            align="end"
          >
            <Dropdown.Toggle
              as="button"
              type="button"
              variant="outline-light"
              className="btn btn-outline-light mb-1 z-index-initial"
              style={{ minWidth: '50px', height: '100%' }}
            >
              {selectedLanguage}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {languages.map((l) => (
                <Dropdown.Item
                  key={l.id}
                  active={l.slug === selectedLanguage}
                  onClick={() => setSelectedLanguage(l.slug)}
                >
                  {l.name}{' '}
                  {newValues[l.slug] && (
                    <AppRemixIcon className="ml-1" icon="check" />
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
    </>
  );
}

const EditorWrapper = styled.div`
  flex-grow: 1;
  .tox-statusbar__branding {
    display: none;
  }
  .ql-editor {
    min-height: ${(props) => props.height}px;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
      'Segoe UI Symbol';
    color: black;
  }
`;
const Title = styled.div`
  top: -6px;
  opacity: 1;
  font-size: 10px;
  color: rgb(74, 115, 151);
  padding: 0px 5px;
  border-top: 1px solid rgb(221, 221, 221);
  border-left: 1px solid rgb(221, 221, 221);
  border-right: 1px solid rgb(221, 221, 221);
`;
